<template src="./index.html"></template>

<script>
export default {
  name: "IdCard",
  props: { user: Object },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
